import { render, staticRenderFns } from "./DocumentsLibraryBlock.vue?vue&type=template&id=59593a83&scoped=true&"
var script = {}
import style0 from "./DocumentsLibraryBlock.vue?vue&type=style&index=0&id=59593a83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59593a83",
  null
  
)

export default component.exports